import { render, staticRenderFns } from "./Modelo4Component.vue?vue&type=template&id=6234e752&scoped=true"
import script from "./Modelo4Component.vue?vue&type=script&lang=js"
export * from "./Modelo4Component.vue?vue&type=script&lang=js"
import style0 from "./Modelo4Component.vue?vue&type=style&index=0&id=6234e752&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6234e752",
  null
  
)

export default component.exports